export default "__VITE_ASSET__C6jaP$nq__"